import { type JSX } from "react";
import { cn } from "./lib/utils";

/** The 9-dot app-grid glyph shown when the sidebar is hovered. */
export function GridDotsIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 16 16" className="size-4" fill="currentColor" aria-hidden="true">
      {[2.6, 8, 13.4].map((y) =>
        [2.6, 8, 13.4].map((x) => <circle key={`${x}-${y}`} cx={x} cy={y} r="1.4" />)
      )}
    </svg>
  );
}

/**
 * The Kore mark: the Two Circles symbol. The only hand-rolled brand SVG in the
 * shell chrome — every other glyph comes from lucide-react or embedded or absolute image.
 */
export function BrandMark({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 25"
      className={cn("size-7 text-sidebar-text", className)}
      fill="currentColor"
      role="img"
      aria-label="Kore"
    >
      <path d="M22.789 24.9898C23.596 23.2887 24 21.4181 24 19.377C24 15.9092 22.8289 12.947 20.4903 10.4907C18.1479 8.03449 15.287 6.80664 11.9042 6.80664C8.52129 6.80664 5.77906 8.05969 3.46725 10.567C1.1559 13.0738 0 16.1114 0 19.6806C0 21.6035 0.377611 23.3724 1.13526 24.9881L4.57732 24.9993C3.59702 23.4797 3.10876 21.707 3.10876 19.6806C3.10876 16.7767 3.94792 14.3918 5.62364 12.5282C7.29997 10.6652 9.41022 9.73244 11.9468 9.73244C14.4834 9.73244 16.6232 10.6562 18.3219 12.5064C20.0198 14.3564 20.8703 16.6605 20.8703 19.4202C20.8703 21.545 20.367 23.4015 19.3609 24.9902L22.7889 24.9898H22.789Z" />
      <path d="M20.4804 1.29738C20.8742 0.878768 21.235 0.446773 21.5621 0.000777808H17.6217C16.0721 1.39274 14.2727 2.08857 12.2213 2.08857C9.94111 2.08857 7.98795 1.39274 6.3658 0L2.36719 0.0020223C2.719 0.479285 3.11103 0.939748 3.54221 1.3845C5.90334 3.81904 8.76275 5.03662 12.1156 5.03662C15.4684 5.03662 18.1326 3.78964 20.4804 1.29723" />
    </svg>
  );
}
